import { colors } from 'quasar'
import { Mapper } from '../utils';

export interface ThemeColorPalette {
  primary: string;
  secondary: string;
  accent: string;
  info: string;
  buttonText: string;
}

export class ThemeColors {
  static get hrv(): ThemeColorPalette {
    return {
      primary: '#151821',
      secondary: '#C7A975',
      accent: '#2C2F36',
      info: '#7b6756',
      buttonText: '#000000',
    };
  }

  static get crv(): ThemeColorPalette {
    return {
      primary: '#2B292A',
      secondary: '#96262C',
      accent: '#464749',
      info: '#9F5053', 
      buttonText: '#ffffff'
    };
  }

  // TODO: Set DRV Suites theme colors
  static get drv(): ThemeColorPalette {
    return {
      primary: '#414141',
      secondary: '#C5B988',
      accent: '#2C2F36',
      info: '#7b6756',
      buttonText: '#000000'
    };
  }

  static setBrandColors(colorPallet: ThemeColorPalette) {
    colors.setBrand('primary', colorPallet.primary);
    colors.setBrand('secondary', colorPallet.secondary);
    colors.setBrand('accent', colorPallet.accent);
    colors.setBrand('info', colorPallet.info);
    colors.setBrand('button-text', colorPallet.buttonText);
  }

  static setCompanyColorTheme(company: string, isWeb: boolean) {
    switch (company) {
      case 'CRV':
        if (isWeb) {
          window.document.title = Mapper.MapPortalName(company);
          ThemeColors.setFavIcon('/images/crv/favicon.ico');
        }
        ThemeColors.setBrandColors(ThemeColors.crv);
        break;
      case 'DRV':
        if (isWeb) {
          window.document.title = Mapper.MapPortalName(company);
          ThemeColors.setFavIcon('/images/drv/favicon.ico');
        }        
        ThemeColors.setBrandColors(ThemeColors.drv);
        break;
      default:
        if (isWeb) {
          window.document.title = Mapper.MapPortalName(company);
          ThemeColors.setFavIcon('/images/hrv/favicon.ico');
        }
        ThemeColors.setBrandColors(ThemeColors.hrv);
        break;
    }
  }  

  private static setFavIcon(url: string) : void {
    const head = window.document.head || document.getElementsByTagName('head')[0];
    const oldLink = window.document.querySelector("link[rel~='icon']");
    if (oldLink) {
      head.removeChild(oldLink);
    }

    const newLink = window.document.createElement('link');
    newLink.rel = 'icon';
    newLink.type = 'image/ico';
    newLink.href = url;

    head.appendChild(newLink);
  }
}
